// extracted by mini-css-extract-plugin
export default {"calendar_wrapper":"lp","modify_order":"mp","modify_order_header":"np","product_details_form_wrapper":"op","c_wrapper":"pp","save_button":"qp","title":"rp","modify_order_title_wrapper":"sp","note":"tp","buttons_wrapper":"up"};
    if(module.hot) {
      // 1711394575887
      var cssReload = require("../../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  